module.exports = __webpack_public_path__ + "static/media/bg-image-41.34c6010a.jpg";